/**
 * @fileoverview gRPC-Web generated client stub for wisetime.account.user.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/account/user/v4/user.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as wisetime_account_user_v4_user_pb from '../../../../wisetime/account/user/v4/user_pb';


export class UserServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorWhoAmI = new grpcWeb.MethodDescriptor(
    '/wisetime.account.user.v4.UserService/WhoAmI',
    grpcWeb.MethodType.UNARY,
    wisetime_account_user_v4_user_pb.WhoAmIRequest,
    wisetime_account_user_v4_user_pb.User,
    (request: wisetime_account_user_v4_user_pb.WhoAmIRequest) => {
      return request.serializeBinary();
    },
    wisetime_account_user_v4_user_pb.User.deserializeBinary
  );

  whoAmI(
    request: wisetime_account_user_v4_user_pb.WhoAmIRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_account_user_v4_user_pb.User>;

  whoAmI(
    request: wisetime_account_user_v4_user_pb.WhoAmIRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_account_user_v4_user_pb.User) => void): grpcWeb.ClientReadableStream<wisetime_account_user_v4_user_pb.User>;

  whoAmI(
    request: wisetime_account_user_v4_user_pb.WhoAmIRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_account_user_v4_user_pb.User) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.account.user.v4.UserService/WhoAmI',
        request,
        metadata || {},
        this.methodDescriptorWhoAmI,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.account.user.v4.UserService/WhoAmI',
    request,
    metadata || {},
    this.methodDescriptorWhoAmI);
  }

}

